<!-- Mobile Navigation -->
 @if (!isDesktop) {
  <div #headerMobile class="header-mobile">
    @if (!hideNavigation) {
      <div
        class="header-content"
        [ngClass]="{ 'no-border': isSearchOpened }"
        >
        <div class="mobile-logo-container" [ngClass]="{ show: !isSearchOpened }">
          <ng-container *ngTemplateOutlet="Logo"></ng-container>
        </div>
        @if (!hideControllers) {
          <shared-search-field
            [ngClass]="{ expanded: isSearchOpened }"
            [opened]="isSearchOpened"
            (onFocus)="searchOnFocus($event)"
          ></shared-search-field>
        }
      </div>
    }
  </div>
} 


<!-- Desktop Navigation -->
 @if (isDesktop) {
  <div class="header-desktop">
    @if (!hideNavigation) {
      <div class="header-content">
        <div class="column-item">
          <div
            class="desktop-logo-container"
            [ngClass]="{ 'add-space': isSearchOpened }"
            >
            <ng-container *ngTemplateOutlet="Logo"></ng-container>
          </div>
          @if (!hideControllers) {
            <div
              class="desktop-navigation"
              [ngClass]="{ show: !isSearchOpened }"
              >
              <ng-container *ngTemplateOutlet="Navigation"></ng-container>
            </div>
          }
        </div>
        @if (!hideControllers) {
          <div
            class="column-item"
            [ngClass]="{ expand: isSearchOpened }"
            >
            <shared-search-field
              [ngClass]="{ expanded: isSearchOpened }"
              [opened]="isSearchOpened"
              (onFocus)="searchOnFocus($event)"
            ></shared-search-field>
            <div class="divider"></div>
            <ng-container *ngTemplateOutlet="preferenceButton"></ng-container>
            <div class="divider"></div>
            @if (!isLoggedIn) {
              <a
                mat-button
                [routerLink]="['/authenticate', 'login']"
                color="primary"
                class="custom-primary"
                >Login</a
                >
              }
              @else if (isLoggedIn) {
                <a
                  mat-button
                  [routerLink]="['/profile', 'edit']"
                  class="transparent-btn"
                  >
                  <img src="/images/icons/navigation-user.svg" alt="" />
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  } 
  <!-- ---------- -->

  <ng-template #Logo>
    <a class="logo-link" [routerLink]="['/']">
      <div class="logo-container">
        <img
        class="logo-mobile"
        [src]="'https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/king-logo_1.png'"
        alt="kingift logo"
        /> 
        <!-- <img
        class="logo-mobile"
        [src]="'/images/kingift-logo.svg'"
        alt="kingift logo"
        />  -->
        </div>
      </a>
    </ng-template> 

    <ng-template #preferenceButton>
      <button class="preference-btn" (click)="openPreference()">
        <div class="btn-context">
          <div class="btn-avatar">
            <img [src]="selectedRegion?.image" alt="" />
          </div>
          <div class="btn-label">EN</div>
        </div>
      </button>
    </ng-template>

    <ng-template #Navigation>
      <div class="nav-container">
        <a
          class="nav-link"
          [routerLink]="['/']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored' }"
          >Home</a
          >
          <button
            mat-button
            class="nav-action"
            [ngClass]="{ active: categoryDialogIsOpen }"
            (click)="openCategories()"
            >
            <div class="button-context">
              <div class="button-title">Categories</div>
              <div class="button-icon">
                <img src="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/arrow-right_1.svg" alt="arrow right" />
              </div>
            </div>
          </button>
          <a class="nav-link" href="https://kingiftcard.com/blog/" target="_blank">
            Blog
          </a>
          <a
            class="nav-link"
      routerLink="{{
        isClubMember ? '/kingclub/club-levels' : '/landing/kingclub'
      }}"
            routerLinkActive="active"
            >
            KingClub

            <span class="badge">
              <img src="{{ throneBadge }}" alt="throne badge" />
            </span>
          </a>

          <a
            class="nav-link"
            [routerLink]="['/pages', 'contact-us']"
            routerLinkActive="active"
            >
            Contact Us
          </a>
        </div>
      </ng-template>

      <ng-template #categoriesDialog>
        @if (categories) {
          <div class="dialog-container">
            @for (item of categories; track item; let i = $index) {
              <a
                class="category-item"
                [routerLink]="[item.url]"
                (click)="closeDialog()"
                (mouseover)="hoveredCategoryIndex = i"
                [ngClass]="item.cssClass"
                >
                <div class="context">
                  <div class="avatar-co">
                    <img
                      class="avatar"
                      [class.filtered-avatar]="hoveredCategoryIndex === i"
                      src="{{ item.avatar }}"
                      [alt]="item.name"
                      />
                    </div>
                    <p class="title">{{ item.name }}</p>
                    @if (item.isBlackFriday) {
                      <span class="offers-txt"> Offers </span>
                    }
                  </div>
                  @if (!item.isBlackFriday) {
                    <img
                      class="action-icon"
                      src="/images/icons/Arrow-right-icon.svg"
                      alt=""
                      />
                  }
                  @if (item.isBlackFriday) {
                    <img
                      class="action-icon"
                      src="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/arrow-right-grey.svg"
                      alt=""
                      />
                  }
                </a>
              }
            </div>
          }
        </ng-template> 

        <ng-template #preferencesDialog> </ng-template>
